import { parseAccountsForFeature } from '@/assets/scripts/parsers/accounts'

/** returns Accounts Balances
@return { Array }
*/
export const getAccountsBalances = state => parseAccountsForFeature(state.accountsBalances)

/** returns Operation Approvals list
@return { Array }
*/
export const getOperationApprovalsList = state => state.operationApprovalsList

/** returns operations status list
@return { Array }
*/
export const getOperationsStatusList = state => state.operationsStatusList

/** returns approvals hasMore value
@return { Boolean }
*/
export const getApprovalsHasMore = state => {
    return state.approvalsHasMore
}

/** returns operations types List
@return { Array }
*/
export const getOperationsTypesList = state => {
    return state.operationsTypesList
}
